// Faqs Accordian

function togglekAccordion(header) {
  const content = header.nextElementSibling;
  const icon = header.querySelector(".k-accordion-icon");

  if (content.style.display === "block") {
    content.style.display = "none";
    icon.style.transform = "";
  } else {
    content.style.display = "block";
    icon.style.transform = "rotate(45deg)";
  }
}



  document.addEventListener("DOMContentLoaded", function() {
    const tabContainer = document.querySelector('.hdt-product-tab__main');
    const tabButtons = document.querySelectorAll('.hdt-product-tab__main button');

    if (tabContainer) {
      tabButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Click hote hi tab ko view ke center ya start mein lana
          this.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center' // Isse active tab center mein aa jayegi
          });
        });
      });
    }
  });


(function () {

  const descriptionButton = document.querySelector('[data-description-button]');

  /* ==========================
     DESCRIPTION TAB
     ========================== */

  if (descriptionButton) {

    descriptionButton.addEventListener('click', function () {

      let descriptionTab =
        document.querySelector('[data-description-tab]');

      if (!descriptionTab) {

        const tabs = document.querySelectorAll(
          'button, a, [role="tab"]'
        );

        tabs.forEach(function (tab) {

          if (
            !descriptionTab &&
            tab.textContent.trim().toLowerCase() === 'description'
          ) {
            descriptionTab = tab;
          }

        });
      }

      if (descriptionTab) {

        descriptionTab.click();

        setTimeout(function () {
          descriptionTab.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 100);

      }

    });

  }

  document.querySelector('.ns-video-btn').addEventListener('click', function(e) {
  e.preventDefault();

  const videoButton = Array.from(document.querySelectorAll('hdt-tab button'))
                           .find(btn => btn.textContent.trim() === 'Video');

  if (videoButton) {
    videoButton.click();
    videoButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});

  /* ==========================
     VIDEO
     ========================== */

  function getEmbedUrl(url) {

    if (!url) return null;

    url = url.trim();

    /* YouTube */

    try {

      const parsed = new URL(url);

      if (
        parsed.hostname.includes('youtube.com') ||
        parsed.hostname.includes('youtu.be')
      ) {

        let id = '';

        if (parsed.hostname.includes('youtu.be')) {
          id = parsed.pathname.replace('/', '').split('/')[0];
        }

        if (parsed.searchParams.get('v')) {
          id = parsed.searchParams.get('v');
        }

        if (parsed.pathname.includes('/shorts/')) {
          id = parsed.pathname.split('/shorts/')[1].split('/')[0];
        }

        if (id) {
          return 'https://www.youtube.com/embed/' +
            encodeURIComponent(id) +
            '?autoplay=1&rel=0';
        }
      }


      /* TikTok */

      if (parsed.hostname.includes('tiktok.com')) {

        const match = parsed.pathname.match(/\/video\/(\d+)/);

        if (match && match[1]) {

          return 'https://www.tiktok.com/player/v1/' +
            match[1] +
            '?autoplay=1';

        }

      }

    } catch (e) {
      return null;
    }

    return null;
  }


  function openVideo() {

    if (!modal || !container || !error) return;

    const url = videoButton?.dataset.videoUrl || '';
    const embedUrl = getEmbedUrl(url);

    container.innerHTML = '';
    error.classList.remove('is-visible');

    if (!embedUrl) {

      error.classList.add('is-visible');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      return;
    }

    const iframe = document.createElement('iframe');

    iframe.src = embedUrl;
    iframe.title = 'Product Video';
    iframe.loading = 'lazy';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    container.appendChild(iframe);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';
  }


  function closeVideo() {

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    if (container) {
      container.innerHTML = '';
    }

    if (error) {
      error.classList.remove('is-visible');
    }

    document.body.style.overflow = '';
  }


  if (videoButton) {
    videoButton.addEventListener('click', openVideo);
  }

  if (closeButtons) {
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeVideo);
    });
  }


  /* ESC */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      modal?.classList.contains('is-open')
    ) {
      closeVideo();
    }

  });

})();



  function nsScrollToReviews() {
    const aliWidget = 
      document.querySelector('#shopify-ali-review') || 
      document.querySelector('#alireview-review-widget') || 
      document.querySelector('.alireviews-widget-section') || 
      document.querySelector('.ali-reviews-widget-box') ||
      document.querySelector('[id*="ali-review"]');

    if (aliWidget) {
      aliWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: document.body.scrollHeight / 2, behavior: 'smooth' });
    }
  }

  function nsToggleBankAccordion(headerElem) {
    const parent = headerElem.closest('.ns-bank-promo-accordion');
    const body = parent.querySelector('.ns-bank-accordion-body');
    
    if (parent.classList.contains('ns-is-open')) {
      parent.classList.remove('ns-is-open');
      body.style.maxHeight = null;
    } else {
      parent.classList.add('ns-is-open');
      body.style.maxHeight = body.scrollHeight + "px";
    }
  }

